<p-toast appendTo="body" position="top-right"></p-toast>
<p-confirmDialog appendTo="body" [baseZIndex]="99999" [style]="{ zIndex: 99999 }"></p-confirmDialog>
<router-outlet></router-outlet>